var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueBotUI',{attrs:{"messages":_vm.data,"options":_vm.botOptions,"bot-typing":_vm.botTyping,"input-disable":_vm.disableInput},on:{"init":_vm.onOpen,"msg-send":_vm.messageSendHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }